import { graphql } from 'react-relay';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';

import {
	type ConfluenceSpaceRoleMode,
	type useSpaceRoleModeQuery$variables as useSpaceRoleModeQueryVariables$variables,
	type useSpaceRoleModeQuery$data as useSpaceRoleModeQuery_Query$data,
} from './__generated__/useSpaceRoleModeQuery.graphql.ts';

export const useSpaceRoleMode = (): {
	spaceRoleMode: ConfluenceSpaceRoleMode | null | undefined;
	isRbacEnabled: boolean;
	loading: boolean;
} => {
	const { cloudId, isLoggedIn } = useSessionData();
	const { data, loading } = useQueryInterop<
		useSpaceRoleModeQuery_Query$data,
		useSpaceRoleModeQueryVariables$variables
	>(
		graphql`
			query useSpaceRoleModeQuery($cloudId: ID!) {
				confluence_spaceRoleMode(cloudId: $cloudId)
			}
		`,
		{
			variables: { cloudId },
			skip: !isLoggedIn,
			onError: (error) => {
				getMonitoringClient().submitError(error, {
					attribution: Attribution.PERMISSIONS_EXPERIENCE,
				});
				markErrorAsHandled(error);
			},
		},
	);

	const isNotPreRoles = data?.confluence_spaceRoleMode
		? data.confluence_spaceRoleMode !== 'PRE_ROLES'
		: false;

	return {
		spaceRoleMode: data?.confluence_spaceRoleMode,
		isRbacEnabled: isNotPreRoles,
		loading,
	};
};
